<div id="main-container" class="col-md-4 gradientBg">
  <h1>{{ mainTitle }}</h1>
</div>
<div id="innerContainer" class="mt-5">
  <div id="CentralRegion">
    <h2 class="pb-2" style="text-transform: uppercase">Central Region</h2>
    @for (row of rowFive; track row) {
      <div class="pb-2">
        <p>
          {{ row.text }}
          <br />
          {{ row.text2 }}
          <br />
          {{ row.text3 }}
          <br />
          {{ row.text4 }}
          <br />
          {{ row.text5 }}
          <br />
          {{ row.text6 }}
          <br />
          {{ row.text7 }}
          <br />
          {{ row.text8 }}
          <br />
          {{ row.text9 }}
          <br />
          {{ row.text10 }}
          <br />
          {{ row.text11 }}
          <br />
          {{ row.text12 }}
          <br />
          {{ row.text13 }}
          <br />
          {{ row.text14 }}
          <br />
          {{ row.text15 }}
          <br />
          {{ row.text16 }}
          <br />
          {{ row.text17 }}
          <br />
          {{ row.text18 }}
          <br />
          {{ row.text19 }}
          <br />
          {{ row.text20 }}
          <br />
          {{ row.text21 }}
          <br />
          {{ row.text22 }}
          <br />
          {{ row.text23 }}
          <br />
          {{ row.text24 }}
          <br />
          {{ row.text25 }}
          <br />
          {{ row.text26 }}
          <br />
          {{ row.text27 }}
          <br />
          {{ row.text28 }}
          <br />
          {{ row.text29 }}
          <br />
          {{ row.text30 }}
          <br />
          {{ row.text31 }}
          <br />
          {{ row.text32 }}
          <br />
          {{ row.text33 }}
        </p>
      </div>
    }
  </div>

  <div id="InlandEmpireRegion">
    <h2 class="pb-2" style="text-transform: uppercase">Inland Empire Region</h2>
    @for (row of rowThree; track row) {
      <div class="pb-2">
        <p>
          {{ row.text }}
          <br />
          {{ row.text2 }}
          <br />
          {{ row.text3 }}
          <br />
          {{ row.text4 }}
          <br />
          {{ row.text5 }}
          <br />
          {{ row.text6 }}
          <br />
          {{ row.text7 }}
          <br />
          {{ row.text8 }}
          <br />
          {{ row.text9 }}
          <br />
          {{ row.text10 }}
          <br />
          {{ row.text11 }}
          <br />
          {{ row.text12 }}
          <br />
          {{ row.text13 }}
          <br />
          {{ row.text14 }}
          <br />
          {{ row.text15 }}
          <br />
          {{ row.text16 }}
          <br />
          {{ row.text17 }}
          <br />
          {{ row.text18 }}
          <br />
          {{ row.text19 }}
          <br />
          {{ row.text20 }}
          <br />
          {{ row.text21 }}
          <br />
          {{ row.text22 }}
        </p>
      </div>
    }
  </div>
  <div id="NorthernRegion">
    <h2 class="pb-2" style="text-transform: uppercase">Northern Region</h2>
    @for (row of rowSeven; track row) {
      <div class="pb-2">
        <p>
          {{ row.text2 }}
          <br />
          {{ row.text3 }}
          <br />
          {{ row.text4 }}
          <br />
          {{ row.text5 }}
          <br />
          {{ row.text6 }}
          <br />
          {{ row.text7 }}
          <br />
          {{ row.text8 }}
          <br />
          {{ row.text9 }}
          <br />
          {{ row.text10 }}
          <br />
          {{ row.text11 }}
          <br />
          {{ row.text12 }}
          <br />
          {{ row.text13 }}
          <br />
          {{ row.text14 }}
          <br />
          {{ row.text15 }}
          <br />
          {{ row.text16 }}
          <br />
          {{ row.text17 }}
          <br />
          {{ row.text18 }}
          <br />
          {{ row.text19 }}
          <br />
          {{ row.text20 }}
          <br />
          {{ row.text21 }}
          <br />
          {{ row.text22 }}
          <br />
          {{ row.text23 }}
          <br />
          {{ row.text24 }}
          <br />
          {{ row.text25 }}
          <br />
          {{ row.text26 }}
        </p>
      </div>
    }
  </div>

  <div id="SouthernRegion">
    <h2 class="pb-2" style="text-transform: uppercase">Southern Region</h2>
    @for (row of rowOne; track row) {
      <div class="pb-2">
        <p>
          {{ row.text }}
          <br />
          {{ row.text2 }}
          <br />
          {{ row.text3 }}
          <br />
          {{ row.text4 }}
          <br />
          {{ row.text5 }}
          <br />
          {{ row.text6 }}
          <br />
          {{ row.text7 }}
          <br />
          {{ row.text8 }}
          <br />
          {{ row.text9 }}
          <br />
          {{ row.text10 }}
          <br />
          {{ row.text11 }}
          <br />
          {{ row.text12 }}
          <br />
          {{ row.text13 }}
          <br />
          {{ row.text14 }}
          <br />
          {{ row.text15 }}
          <br />
          {{ row.text16 }}
          <br />
          {{ row.text17 }}
          <br />
          {{ row.text18 }}
          <br />
          {{ row.text19 }}
          <br />
          {{ row.text20 }}
          <br />
          {{ row.text21 }}
          <br />
          {{ row.text22 }}
          <br />
          {{ row.text23 }}
          <br />
          {{ row.text24 }}
          <br />
          {{ row.text25 }}
          <br />
          {{ row.text26 }}
          <br />
          {{ row.text27 }}
          <br />
          {{ row.text28 }}
          <br />
          {{ row.text29 }}
          <br />
          {{ row.text30 }}
          <br />
          {{ row.text31 }}
          <br />
          {{ row.text32 }}
          <br />
          {{ row.text33 }}
          <br />
          {{ row.text34 }}
        </p>
      </div>
    }
  </div>
</div>
